module.exports = __webpack_public_path__ + "static/img/baas_channel_1.217d9d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/baas_channel_1.png
// module id = TB4M
// module chunks = 0